import find from "lodash/find";
import React, { useContext, useEffect } from "react";
import {
  Box as B,
  Circle,
  pointInCircle,
  pointInPolygon,
  Vector as V,
} from "sat";

import DragDropProvider from "../common/drag/DragDropProvider";
import QuestionContext from "../QuestionContext";

import Draggable from "./common/Draggable";
import Stage from "./common/Stage";
import Prompt from "./shared/Prompt";

const GraphicPositionObject = (props) => {
  const [player, dispatchPlayer] = useContext(QuestionContext);

  // Reveal Key
  useEffect(() => {
    if (player.revealKey) {
      let key;
      for (let i in props.data.scoring.spots) {
        if (props.data.scoring.spots[i].isKey) {
          key = i;
          break;
        }
      }
      let spot = find(props.data.content.spots, ["id", key]);

      // Graphic Position object do not care which token you use (weird...)
      let firstToken = props.data.content.tokens?.[0];

      if (!spot || !firstToken) {
        console.error("No key found for this question");
        return;
      }
      // todo: adjust mark for for shape type/size
      dispatchPlayer({
        type: "RESPONSE",
        data: {
          id: props.data.id,
          score: true,
          response: {
            draggableId: firstToken.id,
            droppableId: spot.id,
            coords: {
              x: spot.coords.x,
              y: spot.coords.y,
            },
          },
        },
      });
    }
  }, [player.revealKey]);

  // remove markup when anything is being dragged
  const handleTokenDragStart = () => {
    dispatchPlayer({
      type: "UNSCORE_RESPONSE",
    });
  };

  const handleTokenDragEnd = (instance) => {
    if (instance.droppableId) {
      let rsp = {
        draggableId: instance.draggableId,
        droppableId: instance.droppableId,
        coords: instance.droppableCoords,
      };

      dispatchPlayer({
        type: "RESPONSE",
        data: {
          id: props.data.id,
          response: rsp,
        },
      });
    }
  };

  let token;
  let rsp;
  let draggableId = player.response?.[props.data.id]?.draggableId;
  if (draggableId) {
    token = find(props.data.content.tokens, ["id", draggableId]);
    // console.log("scaled token", scaledToken);
    rsp = player.response[props.data.id];
  }

  let mark;
  let keys = [];
  if (player.scoreResponses && rsp) {
    mark = "incorrect";
    if (props.data.scoring.spots) {
      for (let i in props.data.scoring.spots) {
        if (props.data.scoring.spots[i].isKey) {
          keys.push(i);
        }
      }
    }

    props.data.content.spots.forEach((sp) => {
      // once we got a correct, no need to check more
      if (mark === "correct") {
        return;
      }

      let collision = false;

      switch (sp.shape) {
        case "rect":
          collision = pointInPolygon(
            new V(rsp.coords.x, rsp.coords.y),
            new B(
              new V(sp.coords.x, sp.coords.y),
              sp.coords.w,
              sp.coords.h,
            ).toPolygon(),
          );
          console.log("is collision", rsp.coords, sp.coords, collision);
          break;
        case "circle":
          collision = pointInCircle(
            new V(rsp.coords.x, rsp.coords.y),
            new Circle(new V(sp.coords.x, sp.coords.y), sp.coords.r),
          );
          break;
        default:
          console.error("Unknown shape type", sp.shape);
          break;
      }

      if (collision && keys.includes(sp.id)) {
        mark = "correct";
      } else {
        mark = "incorrect";
      }
    });
  }

  return (
    <div className="item-player-element item-player-stem">
      <Prompt data={props.data.content.prompt} />
      <DragDropProvider>
        <Stage data={props.data}>
          {player.response?.[props.data.id] && (
            <Draggable
              data={token}
              onDragStart={handleTokenDragStart}
              onDragEnd={handleTokenDragEnd}
              mark={mark}
              x={rsp.coords.x}
              y={rsp.coords.y}
            />
          )}
        </Stage>
        {props.data.content.tokens && (
          <div className="item-player-tokens">
            {props.data.content.tokens?.map((t, idx) => {
              return (
                <Draggable
                  key={idx}
                  data={t}
                  cloneOnDrag
                  onDragStart={handleTokenDragStart}
                  onDragEnd={handleTokenDragEnd}
                  // drags={drags}
                />
              );
            })}
          </div>
        )}
      </DragDropProvider>
    </div>
  );
};
export default GraphicPositionObject;
